// @flow
import React, { useState } from 'react';
import { useFormikContext } from 'formik';

import { ESTIMATE_COMMIT_DETAILS_CONFIG_MAP } from '../../configuration/estimate-commit-details';
import { RATE_CARD_BACKEND_NAME } from '../../constants';
import { useEstimateRateCards } from '../../custom-hooks/useEstimateRateCards';
import { SelectField } from '../../formik-utils/FormFields';

import EstimateRateCardChangeWarningModal from './EstimateRateCardChangeWarningModal';

export const RateCardsContainer = () => {
  const { initialValues } = useFormikContext();
  const [isRCChangeWarningModalOpen, setRCChangeWarningModalOpen] = useState(false);

  const rcVersions = useEstimateRateCards();
  const rcVersionsOptions = [];
  for (const rc of rcVersions) {
    const actionable = rc?.actionable ?? true;
    rcVersionsOptions.push({
      name: rc.name,
      display_name: rc.label,
      shouldNotBeSelectable: !actionable,
    });
  }

  const { backendFieldName, displayName, tooltip } =
    ESTIMATE_COMMIT_DETAILS_CONFIG_MAP.get(RATE_CARD_BACKEND_NAME);

  return (
    <>
      <EstimateRateCardChangeWarningModal
        isOpen={isRCChangeWarningModalOpen}
        setOpen={setRCChangeWarningModalOpen}
      />
      <SelectField
        fieldDisplayName={displayName}
        fieldName={backendFieldName}
        onChange={(event, value) => {
          if (value !== initialValues[RATE_CARD_BACKEND_NAME]) {
            setRCChangeWarningModalOpen(true);
          }
        }}
        options={[...rcVersionsOptions].reverse()}
        tooltip={tooltip}
      />
    </>
  );
};
